<template>
  <div class="extra shadow">
    <div class="top">
      <div class="h4">
        <slot></slot>
      </div>
      <div class="image__right">
        <img :src="'/assets/cards/' + images + '_right.svg'">

      </div>
    </div>
    <div class="image__left">
      <img :src="'/assets/cards/' + images + '_left.svg'">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Extras',
  props: ['images'],
};
</script>

<style scoped lang='scss'>
  @import './../assets/scss/theme';

  .extra {
    flex-grow: 1;
    flex-flow: wrap;
    border-radius: 4px;
    /*min-height: 100%;*/
    background: $white;
    padding: 1.5rem 1.5rem 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .top {
      display: flex;
      justify-content: space-between;
    }

    .h4 {
      font-family: "Hind Madurai", sans-serif;
      font-weight: $font-weight-semi-bold;
      font-size: 1.5rem;
      margin: 0;
    }

    .image {

      &__right {
        > img {
        }
      }

      &__left {
        margin-top: 3rem;
        > img {
        }
      }
    }
  }
</style>
